module.exports = __webpack_public_path__ + "img/upload (1).8e3f973d.svg";